import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, payload) =>
    makeRequest(
        'post',
        `/api/roundtables/${roundtable_id}/sync-assessment-data`, payload
    );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/syncRTAssessmentData.js